<div class="setup-section" [formGroup]="form()">
    <div class="section-header">
        <h3>{{ titleKey() | translate }}</h3>
        <span class="status-indicator"
            [class.status-sent]="result() === NotificationEventResult.SUCCESS"
            [class.status-error]="result() === NotificationEventResult.ERROR"
            [class.status-pending]="!result()">
            @if (result() === NotificationEventResult.SUCCESS) {
                {{ 'ADMIN.DAYS_LEFT.STATUS_SENT' | translate }}
            } @else if (result() === NotificationEventResult.ERROR) {
                {{ 'ADMIN.DAYS_LEFT.STATUS_ERROR' | translate }}
            } @else {
                {{ 'ADMIN.DAYS_LEFT.STATUS_PENDING' | translate }}
            }
        </span>
    </div>

    <p>{{ descriptionKey() | translate }}</p>

    <div class="dates-group">
        @for (date of dates(); track date.controlName) {
            <mat-form-field appearance="fill" color="accent" (click)="picker.open()">
                <mat-label>{{ date.labelKey | translate }}</mat-label>
                <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                <input [formControlName]="date.controlName" matInput [matDatepicker]="picker"
                    [matDatepickerFilter]="dateFilter" />
                <mat-datepicker #picker color="primary"></mat-datepicker>
                <mat-hint>{{ date.hintKey | translate }}</mat-hint>
                @if (form().get(date.controlName)?.hasError('required')) {
                    <mat-error>{{ 'ADMIN.DAYS_LEFT.DATE_REQUIRED_ERROR' | translate }}</mat-error>
                } @else if (date.showAfterDeadlineError && form().get(date.controlName)?.hasError('afterDeadline')) {
                    <mat-error>{{ 'ADMIN.DAYS_LEFT.FUTURE_DATE_ERROR' | translate }}</mat-error>
                }
            </mat-form-field>
        }
    </div>

    <ng-content></ng-content>

    <div class="recipients-preview-row">
        <div class="recipients-row">
            <mat-icon class="recipients-icon">group</mat-icon>
            <span>{{ 'ADMIN.DAYS_LEFT.RECIPIENTS' | translate }}:
                <strong>{{ recipientsKey() | translate }}</strong>
            </span>
        </div>
        <button mat-raised-button color="primary" type="button" (click)="preview.emit()"
            [disabled]="previewDisabled()">
            <mat-icon>visibility</mat-icon>
            {{ 'ADMIN.DAYS_LEFT.PREVIEW_EMAIL' | translate }}
        </button>
    </div>
</div>
